import TalentList from './TalentList'
import TalentCreate from './TalentCreate'
import TalentProfile from './TalentProfile'
import TalentWelcome from './TalentWelcome'
import TalentPackageOptIn from './TalentPackageOptIn'

export default {
  TalentList,
  TalentCreate,
  TalentProfile,
  TalentWelcome,
  TalentPackageOptIn
}
